import {HttpClient} from "@angular/common/http";
import {Component, OnInit} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Currency} from "../../../models/currency";
import {CurrencyControllerService} from "../../../services/currency-controller/currency-controller.service";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "currency",
  templateUrl: "./currency.component.html",
})
export class CurrencyComponent extends TranslatedBaseError implements OnInit {

  public currencies: Currency[] = [];
  public selectedCurrency: Currency = new Currency();
  public newCurrency: string;
  public currencyCodes: any[] = [];
  public editMode: boolean[] = [];
  public editType: string = "";
  public isLoading: boolean = false;

  constructor(private currencyControllerService: CurrencyControllerService,
              private http: HttpClient, toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
    // Taken from https://www.xe.com/iso4217.php, https://www.xe.com/symbols/
    this.http.get("./assets/currency-codes/currency-codes.json")
      .subscribe((res: any[]) => {
        this.currencyCodes = res;
      });
  }

  public ngOnInit() {
    this.getCurrencies();
  }

  public getCurrencies() {
    this.currencyControllerService.getCurrencies().subscribe(
      (data) => {
        this.currencies = data;
        this.resetEdit();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public resetEdit() {
    this.editMode = new Array(this.currencies.length).fill(false);
    this.editType = "";
  }

  public submit(currency: Currency) {
    this.isLoading = true;
    if (currency.id) {
      this.editCurrency(currency);
    } else {
      this.addCurrency(currency);
    }
  }

  public addCurrency(currency: Currency) {
    this.currencyControllerService.addCurrency(currency).subscribe(
      (data) => {
        this.responseSuccessful("Currency added to system!");
        this.isLoading = false;
        this.getCurrencies();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public editCurrency(currency: Currency) {
    this.currencyControllerService.editCurrency(currency).subscribe(
      (data) => {
        this.responseSuccessful("Currency edited!");
        this.isLoading = false;
        this.getCurrencies();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public removeCurrency(isConfirmed, currencyId: string) {
    if (isConfirmed) {
      this.currencyControllerService.removeCurrency(currencyId).subscribe(
        (data) => {
          this.getCurrencies();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public toggleCurrency(currency: Currency) {
    this.isLoading = true;
    if (!currency.isEnabled) {
      this.currencyControllerService.enableCurrency(currency).subscribe(
        (data) => {
          currency.isEnabled = true;
          this.responseSuccessful("Currency enabled!");
          this.isLoading = false;
        },
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.currencyControllerService.disableCurrency(currency).subscribe(
        (data) => {
          currency.isEnabled = false;
          this.responseSuccessful("Currency disabled!");
          this.isLoading = false;
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public disableAllCurrencies() {
    this.currencies.forEach((currency) => {
      currency.isEnabled = false;
    });
  }

  public selected(currencyCode: any) {
    this.selectedCurrency.code = currencyCode.text;
    this.selectedCurrency.name = currencyCode.id;
  }

}
